module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "固定排课",
      "width": "950"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    staticClass: "form scheduling"
  }, [_c('Row', {
    staticClass: "module"
  }, [_c('Col', {
    attrs: {
      "span": 3,
      "offset": 1
    }
  }, [_c('h3', [_vm._v("学生信息")])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 18
    }
  }, [_c('Row', [_c('Col', {
    staticClass: "row",
    attrs: {
      "span": 8
    }
  }, [_c('label', {
    staticClass: "field"
  }, [_vm._v("学生姓名：")]), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.user.nickname))])]), _vm._v(" "), _c('Col', {
    staticClass: "row",
    attrs: {
      "span": 10
    }
  }, [_c('label', {
    staticClass: "field"
  }, [_vm._v("学生手机号：")]), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.user.mobile))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('Col', {
    staticClass: "row",
    attrs: {
      "span": 8
    }
  }, [_c('label', {
    staticClass: "field"
  }, [_vm._v("常规课次数：")]), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.bookUserPackage.routineNum))])]), _vm._v(" "), _c('Col', {
    staticClass: "row",
    attrs: {
      "span": 8
    }
  }, [_c('label', {
    staticClass: "field"
  }, [_vm._v("常规课已选次数：")]), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.bookUserPackage.routineSelectNum))])]), _vm._v(" "), _c('Col', {
    staticClass: "row",
    attrs: {
      "span": 8
    }
  }, [_c('label', {
    staticClass: "field"
  }, [_vm._v("常规课已上次数：")]), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.bookUserPackage.routineEndNum))])])], 1)], 1)], 1), _vm._v(" "), _c('Row', {
    staticClass: "module"
  }, [_c('Col', {
    attrs: {
      "span": 3,
      "offset": 1
    }
  }, [_c('h3', [_vm._v("历史课程")])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 20
    }
  }, [_c('Table', {
    staticClass: "compact",
    attrs: {
      "size": "small",
      "columns": _vm.bookLessonOpenedColumn,
      "data": _vm.bookLessonOpenedList
    }
  })], 1)], 1), _vm._v(" "), _c('Row', {
    staticClass: "module"
  }, [_c('Col', {
    attrs: {
      "span": 3,
      "offset": 1
    }
  }, [_c('h3', [_vm._v("上课时间")])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 20
    }
  }, [_c('Checkbox-group', {
    model: {
      value: (_vm.scheduleIndexList),
      callback: function($$v) {
        _vm.scheduleIndexList = $$v
      },
      expression: "scheduleIndexList"
    }
  }, _vm._l((_vm.courseScheduleListData), function(item, index) {
    return _c('Row', {
      key: index,
      staticStyle: {
        "margin-bottom": "5px"
      },
      attrs: {
        "gutter": 8
      }
    }, [_c('Col', {
      attrs: {
        "span": 9
      }
    }, [_c('Checkbox', {
      attrs: {
        "label": index,
        "disabled": ""
      }
    }, [_c('i')]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$moment(item.day, 'X').format('YYYY-MM-DD')) + " " + _vm._s(_vm.$constant.weekZh[item.week]) + " " + _vm._s(_vm.$moment.unix(item.startTime).utc().format('HH:mm')) + " - " + _vm._s(_vm.$moment.unix(item.endTime).utc().format('HH:mm')))])], 1), _vm._v(" "), _c('Col', {
      attrs: {
        "span": 5
      }
    }, [_c('span', [_vm._v(_vm._s(item.firstName) + " " + _vm._s(item.lastName))])]), _vm._v(" "), _c('Col', {
      attrs: {
        "span": 5
      }
    }, [(item.lsnSelStatus === 6 || item.lsnSelStatus === 13) ? _c('span', [_vm._v(_vm._s(item.lsnSelStatus === 13 ? '老师离职' : '老师请假'))]) : _c('Select', {
      attrs: {
        "size": "small",
        "filterable": "",
        "transfer": ""
      },
      on: {
        "on-change": function($event) {
          return _vm.onBookMaterialLevelChange(item, index)
        }
      },
      model: {
        value: (item.levelId),
        callback: function($$v) {
          _vm.$set(item, "levelId", $$v)
        },
        expression: "item.levelId"
      }
    }, _vm._l((_vm.bookMaterialLevelList), function(levelItem) {
      return _c('Option', {
        key: levelItem.id,
        attrs: {
          "value": levelItem.id
        }
      }, [_vm._v(_vm._s(levelItem.title))])
    }), 1)], 1), _vm._v(" "), _c('Col', {
      attrs: {
        "span": 6
      }
    }, [(item.lsnSelStatus === 6 || item.lsnSelStatus === 13) ? _c('span', [_vm._v("不占课件顺序")]) : _c('Select', {
      attrs: {
        "size": "small",
        "filterable": "",
        "transfer": ""
      },
      model: {
        value: (item.lessonId),
        callback: function($$v) {
          _vm.$set(item, "lessonId", $$v)
        },
        expression: "item.lessonId"
      }
    }, _vm._l((_vm.bookMaterialLessonsList[index]), function(lessonItem) {
      return _c('Option', {
        key: lessonItem.id,
        attrs: {
          "value": lessonItem.id
        }
      }, [_vm._v(_vm._s(lessonItem.titleEn))])
    }), 1)], 1), _vm._v(" "), _c('Col', {
      attrs: {
        "span": 4
      }
    }, [_c('Select', {
      model: {
        value: (item.schoolId),
        callback: function($$v) {
          _vm.$set(item, "schoolId", $$v)
        },
        expression: "item.schoolId"
      }
    }, _vm._l((_vm.$constant.schoolEnums), function(item) {
      return _c('Option', {
        key: item.code,
        attrs: {
          "value": item.code
        }
      }, [_vm._v(_vm._s(item.text))])
    }), 1)], 1)], 1)
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingAdd
    },
    on: {
      "click": _vm.add
    }
  }, [_vm._v("保存")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2a0ea70a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/modal/CourseSchedulingModal.vue
// module id = 1719
// module chunks = 8